import { api } from "./api";

export const esslDeviceList = async (addUrl = "") => {
    return await api.get(`/essl/device/list?${addUrl}`);
};

export const esslDeviceAdd = async (data) => {
    return await api.post(`/essl/device/add`, data);
};

export const esslDeviceUpdate = async (data) => {
    return await api.post(`/essl/device/update`, data);
};

export const esslDeviceDelete = async (id) => {
    return await api.post(`/essl/device/delete`, { id });
};

export const esslDeviceStatusChange = async (id) => {
    return await api.post(`/essl/device/status/change`, { id });
};

export const esslDevicesLogs = async (addUrl = "") => {
    return await api.get(`/essl/devices/logs?${addUrl}`);
};

export const esslEmployeesList = async (addUrl = "") => {
    return await api.get(`/essl/employees/list?${addUrl}`);
};
